@use "styles/mixins/_fonts.scss" as fonts;

.field-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: var(--size-spacing-s);
  margin-bottom: var(--size-spacing-xs);

  &-right {
    @include fonts.body-accent-xs;

    color: var(--color-text-subtle);
  }
}

.label {
  display: block;
  overflow-wrap: anywhere;

  &-mandatory-symbol {
    margin-left: var(--size-spacing-s);
  }
}

//  DESCRIPTION
.has-description {
  .label {
    margin-bottom: var(--size-spacing-2xs);
  }
}

.description {
  @include fonts.body-accent-xs;

  color: var(--color-text-subtle);
  overflow-wrap: anywhere;
}
